import { createAsyncThunk } from "@reduxjs/toolkit";
import { createMedia, deleteMediaByIds, getMedia,createFolderApi, getFolder, getMediaByFolderId, checkMediaUrl, mediaMoveToFolder, getMoveFolderApi,deleteFolderId, updateFolderName, getMediaVideo } from "helpers/backend_helper";
// import { createMedia, deleteMediaByIds, getMedia,createFolderApi, getFolder, getMediaByFolderId, checkMediaUrl,  } from "helpers/backend_helper";
import { toast } from "react-toastify";


interface Media {
  id: string;
  url: string;
  isExternal: boolean;
  metaData: {
    height: number;
    width: number;
    fileType: string;
    fileFormat: string;
    name: string;
    duration?: number;
  };
  folderId: string;
}

interface Folder{
    folderName: string;
    parentId: string
}

interface FolderUpdate{
  folderName: string;
  _id: string
}

export const createMediaCenter = createAsyncThunk(
  'media/createMediaCenter',
  async (media: Media[] | Media, { rejectWithValue }) => {
    try {
      const mediaArray = Array.isArray(media) ? media : [media];
      const mediaDetailsArray = mediaArray.map((item) => {
        if (!item || !item.metaData) {
          throw new Error('Invalid media item or missing metaData');
        }

        return {
          isExternal: false,
          url: item.url,
          metaData: {
            height: item.metaData.height || 0,
            width: item.metaData.width || 0,
            fileType: item.metaData.fileType || 'unknown',
            fileFormat: item.metaData.fileFormat || 'unknown',
            name: item.metaData.name || 'unknown',
            duration: item.metaData.duration || 0,
          },
          folderId: item.folderId || '',
        };
      });

      const response: any = await createMedia({ media: mediaDetailsArray });
      if (response?.isSuccess) {
        toast.success("Media uploaded successfully", { autoClose: 1000 });
        return response.data;
        
      } else {
        toast.error("Media uploaded failed", { autoClose: 1000 });
        return rejectWithValue(response?.message || 'Media upload failed');
      }
    } catch (error: any) {
      return rejectWithValue(error.message || 'Unexpected error occurred');
    }
  }
);

export const createMediaCenterUrl = createAsyncThunk(
  'media/createMediaCenter',
  async (media: Media[], { rejectWithValue }) => {
    try {
      const mediaDetailsArray = media.map((item) => {
        if (!item || !item.metaData) {
          throw new Error('Invalid media item or missing metaData');
        }
        return {
          isExternal: true,
          url: item.url,
          metaData: {
            height: item.metaData.height || 0,
            width: item.metaData.width || 0,
            fileType: item.metaData.fileType || 'unknown',
            fileFormat: item.metaData.fileFormat || 'unknown',
            name: item.metaData.name || 'unknown',
            duration: item.metaData.duration || 0,
          },
          folderId: item.folderId || '',
        };
      });

      const response: any = await createMedia({ media: mediaDetailsArray });
      if (response?.isSuccess) {
        toast.success("Media uploaded successfully",{autoClose:1000});
        return response.data;
      } else {
        toast.error("Media Uploaded Failed",{autoClose:1000})
        return rejectWithValue(response?.message || 'Media upload failed');
      }
    } catch (error: any) {
      return rejectWithValue(error.message || 'Unexpected error occurred');
    }
  }
);




export const getmedia = createAsyncThunk(
  "media/getMedia",
  async ({ folderid,keyword, stardate, enddate }: { folderid:string,keyword: string; stardate: number; enddate: number }) => {
    try {
      const response = await getMedia(folderid,1, 100,keyword, stardate, enddate.toString(), );  
      return response.data;
    } catch (error: any) {
      return error.message || "An error occurred";
    }
  }
);

export const getVideo = createAsyncThunk(
  "media/getMediaVideo",
  async ({  page, count,keyword }: {  page: number; count: number,keyword: string; }) => {
    try {
      const response = await getMediaVideo(page,count,keyword, );  
      return response.data;
    } catch (error: any) {
      return error.message || "An error occurred";
    }
  }
);

export const deleteMedia = createAsyncThunk(
  'media/delete',
  async ({ ids }: { ids: any; }, { rejectWithValue }) => {
    try {
      const response: any = await deleteMediaByIds(ids);
      if(response && response.data && response.isSuccess){

        return response.data;
      }
      else{
        return rejectWithValue(response.message || 'Something went wrong');
      }
      // navigate('/manage-products');
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const deleteFolder = createAsyncThunk(
  'folder/delete',
  async ({ id }: { id: any; }, { rejectWithValue }) => {
    try {
      const response: any = await deleteFolderId(id);
      return response.data;
      // navigate('/manage-products');
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);


export const createFolder = createAsyncThunk(
  'media/createFolder',
  async (folder: Folder, { rejectWithValue }) => {
    try {
      const folderData = {
        folderName: folder.folderName,
        parentId: folder.parentId,
      };
      const response: any = await createFolderApi(folderData); 
      if (response?.isSuccess) {
        return response.data; 
      } else {
        toast.error(response.message,{autoClose:1000});
        return rejectWithValue(response?.message || 'Folder creation failed');
      }
    } catch (error: any) {
      console.error('Error creating folder:', error);
      return rejectWithValue(error.message || 'Unexpected error occurred');
    }
  }
);

export const updateFolder = createAsyncThunk(
  'folder/updateFolderName',
  async (folder:FolderUpdate, { rejectWithValue }) => {
    try {
      const folderData = {
        folderName: folder.folderName,
        _id: folder._id,
      };
      const response: any = await updateFolderName(folderData); 
      if (response?.data && response?.isSuccess) {
        return response.data; 
      } else {
        toast.error(response.message,{autoClose:1000});
        return rejectWithValue(response?.message || 'Folder updated failed');
      }
    } catch (error: any) {
      console.error('Error creating folder:', error);
      return rejectWithValue(error.message || 'Unexpected error occurred');
    }
  }
)


export const getfolder = createAsyncThunk(
  "media/getFolder",
  async (parentid: string) => {
    try {
      const response = await getFolder(1, 100, parentid);  
      if (response?.data) {
        return response.data;
      }else{
        return response || "An error occurred";
      }

    } catch (error: any) {
      return error.message || "An error occurred";
    }
  }
);

export const getfolderByProduct = createAsyncThunk(
  "media/getFolderByProduct", 
  async (parentid: string) => {
    try {
      const response = await getFolder(1, 100, parentid);  
      if (response?.data) {
        return response.data;
      }else{
        return response || "An error occurred";
      }

    } catch (error: any) {
      return error.message || "An error occurred";
    }
  }
);


export const getmediaByProduct = createAsyncThunk(
  "media/getMediaByProduct",
  async ({ folderid,keyword, stardate, enddate }: { folderid:string,keyword: string; stardate: number; enddate: number }) => {
    try {
      const response = await getMedia(folderid,1, 100,keyword, stardate, enddate.toString(), );  
      return response.data;
    } catch (error: any) {
      return error.message || "An error occurred";
    }
  }
);

// export const getMediaByFolderID = createAsyncThunk(
//   "media/getMediaByFolderId",
//   async (folderId: any, thunkAPI) => {
//     try {
//       const response = await getMediaByFolderId(1, 100, folderId);
//       console.log("API response:", response);
//       return response.data;
//     } catch (error: any) {
//       console.error("Error in getMediaByFolderID:", error);
//       return thunkAPI.rejectWithValue(error.response?.data || { message: "An unknown error occurred" });
//     }
//   }
// );

export const checkMediaUrlThunk = createAsyncThunk(
  'media/checkMediaUrl',
  async (data: any, thunkAPI) => {
    try {
      const response = await checkMediaUrl(data);
      if (response.data?.isSuccess) {
        return {
          isSuccess: response.data.isSuccess,
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        return thunkAPI.rejectWithValue(response.data.message || "Media URL check failed");
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message || "Unexpected error occurred");
    }
  }
);


export const mediaMove = createAsyncThunk(
  'media/mediaMoveToFolder',
  async (data: any, thunkAPI) => {
    try {
      const response = await mediaMoveToFolder(data);
      if (response.data?.isSuccess) {
        return response.data; // Return the data if success
      } else {
        toast.error(response.data.message,{autoClose:1000})
        return thunkAPI.rejectWithValue(response.data.message || 'Media move failed');
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message || 'Unexpected error occurred');
    }
  }
);


export const getMoveFolder = createAsyncThunk(
  "media/getMoveFolder",
  async (parentid: string) => {
    try {
      const response = await getMoveFolderApi(1, 100, parentid);  
      return response.data;
    } catch (error: any) {
      return error.message || "An error occurred";
    }
  }
);

